// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_jg-0";
export var actionModalContentContainer = "_jg-1";
export var createTagButton = "_jg-2";
export var footerContainer = "_jg-7";
export var fullWidthDivider = "_jg-3";
export var hasCreateTagButton = "_jg-4";
export var noCreateTagButton = "_jg-5";
export var tagsContainer = "_jg-6";
export var tagsModalContentContainer = "_jg-8";